/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Company-level setting for whether family members appear as their own rows under Medlemmar.
 * Only meaningful when FamilyMemberConfiguration is Enabled.
 * @export
 */
export const WebApiModelsEnumerationTypesFamilyMemberDisplayMode = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesFamilyMemberDisplayMode = typeof WebApiModelsEnumerationTypesFamilyMemberDisplayMode[keyof typeof WebApiModelsEnumerationTypesFamilyMemberDisplayMode];


export function WebApiModelsEnumerationTypesFamilyMemberDisplayModeFromJSON(json: any): WebApiModelsEnumerationTypesFamilyMemberDisplayMode {
    return WebApiModelsEnumerationTypesFamilyMemberDisplayModeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesFamilyMemberDisplayModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesFamilyMemberDisplayMode {
    return json as WebApiModelsEnumerationTypesFamilyMemberDisplayMode;
}

export function WebApiModelsEnumerationTypesFamilyMemberDisplayModeToJSON(value?: WebApiModelsEnumerationTypesFamilyMemberDisplayMode | null): any {
    return value as any;
}

